// Ürün sayfası kurulumu. 13 Eki 2026: aroma (kardeş ürün) geçişi sayfayı yenilemeden içeriği değiştirdiği için kurulum
// fonksiyon oldu (window.petidiUrunKur) — her çağrıda öncekinin belge/pencere dinleyicileri, sayaçları ve gözlemcileri
// AbortController ile kapatılır (çift dinleyici olmasın).
window.petidiUrunKur = function () {
  'use strict';
  if (window.__pdAc) window.__pdAc.abort();
  var ac = new AbortController(), sig = { signal: ac.signal };
  window.__pdAc = ac;
  var pd = document.querySelector('[data-pd]');
  if (!pd) return;
  // Çeviri sözlüğü (theme.liquid window.PETIDI_T, Liquid `t` ile dolar); yoksa Türkçe varsayılan. [x] yer tutucuları o değerle değişir.
  var T = window.PETIDI_T || {};
  function tt(k, d, o) { var s = T[k] || d; if (o) Object.keys(o).forEach(function (x) { s = s.split('[' + x + ']').join(o[x]); }); return s; }

  // INP (17 Eki 2026): dokunuşta önce görünen değişiklik çizilsin, ağır iş çizimden SONRA. rAF çizimden hemen önce çalışır,
  // içindeki setTimeout çizimden sonraki ilk görev olur. Sekme gizliyken rAF beklemez → doğrudan setTimeout.
  function boyaSonra(fn) {
    if (document.hidden || !window.requestAnimationFrame) { setTimeout(fn, 0); return; }
    requestAnimationFrame(function () { setTimeout(fn, 0); });
  }
  window.petidiBoyaSonra = boyaSonra;
  // Metni düğüm ekleyip çıkarmadan yaz: tek metin düğümü varsa yalnız nodeValue değişir (textContent eski düğümü silip yenisini
  // ekler → Shopify'ın load_feature / web pixel gözlemcileri her seferinde sayfayı tarar). Değer aynıysa hiç dokunmaz.
  function yaz(el, t) {
    if (!el) return;
    t = t == null ? '' : String(t);
    var c = el.firstChild;
    if (c && c.nodeType === 3 && !c.nextSibling) { if (c.nodeValue !== t) c.nodeValue = t; }
    else if (el.textContent !== t) el.textContent = t;
  }

  var idInput = pd.querySelector('[data-pd-id]');
  var nowEl = pd.querySelector('[data-pd-now]');
  var compareEl = pd.querySelector('[data-pd-compare]');
  var badgeEl = pd.querySelector('[data-pd-badge]');
  var saveEl = pd.querySelector('[data-pd-save]');
  var puanEl = pd.querySelector('[data-pd-puan]');
  var puanHEl = pd.querySelector('[data-pd-puanh]');
  var sktWrap = pd.querySelector('.pd__skt');
  var sktEl = pd.querySelector('[data-pd-skt]');
  var sktLabel = pd.querySelector('[data-pd-sktlabel]');
  var sktIco = pd.querySelector('[data-pd-sktico]');
  var sktFallback = sktWrap ? (sktWrap.getAttribute('data-pd-sktfallback') || '') : '';
  var addBtn = pd.querySelector('[data-pd-addcart]');

  // ---- Yetkili distribütörden tedarik (eski adı "Gelince haber ver", 15 Eki 2026): tükenmiş boyda telefon → ahtapot /apps/yorum/stok-haber ----
  var haberEl = pd.querySelector('[data-haber]');
  function haberGoster(avail) {
    if (!haberEl) return;
    haberEl.hidden = !!avail;
    var f = haberEl.querySelector('[data-haber-form]'), a = haberEl.querySelector('[data-haber-ac]'), s = haberEl.querySelector('[data-haber-sonuc]');
    if (f) f.hidden = true; if (a) a.hidden = false; if (s) { s.hidden = true; s.classList.remove('is-hata'); }
  }
  if (haberEl) {
    var hAc = haberEl.querySelector('[data-haber-ac]'), hForm = haberEl.querySelector('[data-haber-form]'), hSonuc = haberEl.querySelector('[data-haber-sonuc]');
    var hYaz = function (m, hata) { hSonuc.textContent = m; hSonuc.hidden = false; hSonuc.classList.toggle('is-hata', !!hata); };
    hAc.addEventListener('click', function () { hAc.hidden = true; hForm.hidden = false; var i = hForm.querySelector('input'); if (i) i.focus(); });
    // Sepete ekle formunun içinde: Enter sepete eklemesin, haber kaydı yapsın
    hForm.querySelector('input').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); haberGonder(); } });
    hForm.querySelector('[data-haber-gonder]').addEventListener('click', haberGonder);
    function haberGonder() {
      var inp = hForm.querySelector('input'), btn = hForm.querySelector('[data-haber-gonder]');
      if (btn.disabled) return;
      var rakam = String(inp.value || '').replace(/\D/g, '').replace(/^90/, '').replace(/^0/, '');
      if (!/^5\d{9}$/.test(rakam)) { hYaz(tt('haber_tel', 'Cep telefonunu 05xx xxx xx xx biçiminde yaz.'), true); inp.focus(); return; }
      var idIn = pd.querySelector('form [name="id"]');
      btn.disabled = true;
      fetch('/apps/yorum/stok-haber', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ v: idIn ? idIn.value : '', tel: rakam, ad: haberEl.getAttribute('data-ad') || '' }) })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          btn.disabled = false;
          if (j && j.ok && (j.durum === 'kayit' || j.durum === 'zaten')) {
            hForm.hidden = true;
            hYaz(j.durum === 'zaten' ? tt('haber_zaten', 'Bu numarayla talebin zaten var; ürün depomuza girince haber vereceğiz.') : tt('haber_alindi', 'Talebini aldık! Ürün depomuza girince ilk sana WhatsApp\'tan haber vereceğiz.'));
          } else if (j && j.durum === 'stokta') hYaz(tt('haber_stokta', 'Bu boy şu an stokta. Sayfayı yenileyip sepete ekleyebilirsin.'));
          else if (j && j.error === 'telefon') hYaz(tt('haber_tel', 'Cep telefonunu 05xx xxx xx xx biçiminde yaz.'), true);
          else if (j && j.error === 'sinir') hYaz(tt('haber_sinir', 'Bugün çok sayıda talep bıraktın, yarın tekrar dene.'), true);
          else hYaz(tt('haber_hata', 'Kaydedemedik, birazdan tekrar dene.'), true);
        })
        .catch(function () { btn.disabled = false; hYaz(tt('haber_hata', 'Kaydedemedik, birazdan tekrar dene.'), true); });
    }
  }
  var addText = pd.querySelector('[data-pd-addtext]');
  var addIsleniyor = false;   // Sepete Ekle isteği sürüyor (düğme kilitli, "İşleniyor…")
  var taksitEl = pd.querySelector('[data-pd-taksit]');
  var freeshipEl = pd.querySelector('[data-pd-freeship]');
  // Kargo kutusu (UX #11): seçili varyantın net fiyatı + sepetteki tutar eşiği geçiyor mu?
  var fsNet = freeshipEl ? +freeshipEl.getAttribute('data-net') || 0 : 0;
  var fsThr = freeshipEl ? +freeshipEl.getAttribute('data-threshold') || 0 : 0;
  var fsCart = 0;
  var fsSub = freeshipEl && freeshipEl.querySelector('[data-fs-sub]');
  var fsSubDef = fsSub ? fsSub.textContent : '';
  function fsTL(c) { var v = c / 100; return v.toLocaleString('tr-TR', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: v % 1 ? 2 : 0 }) + ' TL'; }
  function fsRender() {
    if (!freeshipEl || !fsThr) return;
    var st = fsNet >= fsThr ? 'free' : (fsCart > 0 && fsCart + fsNet >= fsThr ? 'cart' : 'paid');
    freeshipEl.setAttribute('data-state', st);
    if (!fsSub) return;
    if (st === 'cart') fsSub.textContent = tt('fs_gecti', 'Sepetindekilerle birlikte [tutar] sınırını geçiyorsun', { tutar: fsTL(fsThr) });
    else if (st === 'paid' && fsCart > 0) fsSub.innerHTML = tt('fs_kaldi', 'Bu ürünle birlikte ücretsiz kargoya <strong>[tutar]</strong> kaldı', { tutar: fsTL(fsThr - fsCart - fsNet) });
    else fsSub.textContent = fsSubDef;
  }
  function fsSepet() {
    if (!freeshipEl || !fsThr) return;
    fetch((window.PETIDI_KOK || '') + '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { fsCart = c.total_price || 0; fsRender(); }).catch(function () {});
  }
  fsSepet();
  var installmentEl = pd.querySelector('[data-pd-installment]');
  var unitEl = pd.querySelector('[data-pd-unit]');
  // Ürün bilgi kartı [data-pd] dışında (ayrı section) — document'ten al
  // Varyanta göre değişen satırlar: veri anahtarı -> hücre
  var pinfoRows = { weight: document.querySelector('[data-pinfo-weight]'), barcode: document.querySelector('[data-pinfo-barcode]'), sku: document.querySelector('[data-pinfo-sku]') };

  var currentPreorder = false;
  var renderShipFn = null;
  var tModalEl = pd.querySelector('[data-taksit-modal]');
  var currentPriceCents = tModalEl ? (Number(tModalEl.getAttribute('data-pricecents')) || 0) : 0;
  var lowStockEl = pd.querySelector('[data-pd-lowstock]');

  /* ---- Kampanya bitişine geri sayım + sepet indirimi notu ----
   * Kampanya TEK BİR VARYANTA kurulmuş olabilir, o yüzden ikisi de SEÇİLİ
   * VARYANTA bağlı: Liquid markup'ı (kampanya varsa) gizli basıyor, burası
   * varyant değiştikçe açıp kapatıyor ve sayacı yeniden kuruyor.
   * Bitiş tarihi ahtapot'un custom.sepet_indirim metafield'ından geliyor;
   * fiyatı Liquid zaten indirimli basıyor, burada yalnız kalan süre var. */
  var cdEl = pd.querySelector('[data-pd-flash]');
  var cdTime = cdEl && cdEl.querySelector('[data-pd-cdtime]');
  var cdNameEl = cdEl && cdEl.querySelector('[data-pd-flashname]');
  var discEl = pd.querySelector('[data-pd-cartdisc]');
  var cdTimer = null, cdSon = 0, cdCanli = false;

  function cdIki(n) { return (n < 10 ? '0' : '') + n; }

  function cdDur() { if (cdTimer) { clearInterval(cdTimer); cdTimer = null; } }
  ac.signal.addEventListener('abort', cdDur);

  function cdTick() {
    var kalan = cdSon - Date.now();
    if (kalan <= 0) {
      // Sayfa açıkken süre dolduysa sunucudaki fiyat değişmiştir; yanlış fiyat
      // göstermektense bir kez tazeliyoruz. AMA sayaç daha en baştan "süresi
      // dolmuş" geldiyse tazelemiyoruz: ziyaretçinin saati ileri olabilir ve
      // sunucu indirimi hâlâ geçerli sayıyor olabilir — o durumda reload
      // sonsuz döngüye girerdi. Sadece sessizce gizle.
      cdDur();
      cdEl.hidden = true;
      if (cdCanli) window.location.reload();
      return;
    }
    cdCanli = true;
    var sn = Math.floor(kalan / 1000);
    var gun = Math.floor(sn / 86400);
    var saat = Math.floor((sn % 86400) / 3600);
    var dk = Math.floor((sn % 3600) / 60);
    var sank = sn % 60;
    // Kutular: gün varsa 4, yoksa 3 (sa : dk : sn).
    var kutular = gun > 0 ? [tt('cd_gun', '[n]g', { n: gun }), cdIki(saat), cdIki(dk), cdIki(sank)] : [cdIki(saat), cdIki(dk), cdIki(sank)];
    // Saniyede bir: kutu sayısı aynıysa yalnız rakamlar (nodeValue) değişir — eskiden her saniye innerHTML, sayfadaki
    // bütün childList gözlemcilerini (Shopify load_feature, web pixel, odak tuzağı) tetikliyordu (INP, 17 Eki 2026).
    var kutuEl = cdTime.querySelectorAll('.pd__flash-box');
    if (kutuEl.length === kutular.length) {
      for (var j = 0; j < kutular.length; j++) yaz(kutuEl[j], kutular[j]);
    } else {
      var html = '';
      for (var i = 0; i < kutular.length; i++) {
        if (i) html += '<i class="pd__flash-sep">:</i>';
        html += '<b class="pd__flash-box">' + kutular[i] + '</b>';
      }
      cdTime.innerHTML = html;
    }
    var acil = kalan < 86400000;   // son 24 saat vurgusu
    if (cdEl.classList.contains('is-urgent') !== acil) cdEl.classList.toggle('is-urgent', acil);
    if (cdEl.hidden) cdEl.hidden = false;
  }

  function cdKur(bitis, ad) {
    if (!cdEl || !cdTime) return;
    cdDur();
    cdCanli = false;
    if (ad && cdNameEl) cdNameEl.textContent = ad;
    var t = bitis ? new Date(bitis).getTime() : NaN;
    if (!isFinite(t)) { cdEl.hidden = true; return; }
    cdSon = t;
    cdTick();
    if (!cdEl.hidden) cdTimer = setInterval(cdTick, 1000);
  }

  function indirimNotu(varMi, ad) {
    if (!discEl) return;
    discEl.hidden = !varMi;
  }

  // ---- Satın alma şekli + Petidi Club (snippets/club-secim.liquid; 13 Eki 2026 modeli) ----
  // Düzenli teslimat seçiliyken üstteki fiyat ilk sipariş fiyatını gösterir (normal fiyat üstü çizili). Club fiyata dokunmaz.
  var clubEl = pd.querySelector('[data-club]');
  var clubMap = {};
  try { var cj = clubEl && clubEl.querySelector('[data-club-fiyat]'); if (cj) clubMap = JSON.parse(cj.textContent); } catch (e) { clubMap = {}; }
  var dtHediyeMap = {};
  try { var hj = clubEl && clubEl.querySelector('[data-dt-hediye-map]'); if (hj) dtHediyeMap = JSON.parse(hj.textContent); } catch (e) { dtHediyeMap = {}; }
  function clubFiyat(vid) {
    var f = clubMap[String(vid)];
    if (!clubEl || !f) return;
    clubEl.querySelectorAll('[data-dt-c]').forEach(function (el) { yaz(el, f.d); });
    // Boy başına ilk oran (20 Eki 2026, custom.abone_ilk_oran): "%N indirim" seçili boya göre
    if (f.o) clubEl.querySelectorAll('[data-dt-o]').forEach(function (el) { el.textContent = f.o; });
    clubEl.querySelectorAll('[data-club-n]').forEach(function (el) { yaz(el, f.n); });
    if (f.s) clubEl.querySelectorAll('[data-dt-s]').forEach(function (el) { yaz(el, f.s); });
    if (f.l) clubEl.querySelectorAll('[data-dt-l]').forEach(function (el) { yaz(el, f.l); });
    // Abonelik fiyatlarının kg karşılığı (16 Eki 2026): ilk sipariş (dc) ve sonraki siparişler (sc) — tek seferlikteki gibi "(… / Kg)"
    var vb = pd.querySelector('[data-variant-id="' + vid + '"]'), kg = vb ? parseFloat(vb.getAttribute('data-kg')) || 0 : 0;
    function birim(c) {
      if (!(kg > 0 && c > 0)) return '';
      var n = Math.round(c / kg) / 100;
      return '(' + n.toLocaleString('tr-TR', n % 1 ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : {}) + ' TL / Kg)';
    }
    [['[data-dt-birim]', f.dc], ['[data-dt-sbirim]', f.sc]].forEach(function (x) {
      var t = birim(x[1]);
      clubEl.querySelectorAll(x[0]).forEach(function (el) { yaz(el, t); if (el.hidden !== !t) el.hidden = !t; });
    });
    clubEl.querySelectorAll('[data-dt-opt]').forEach(function (el) {
      if (el.classList.contains('is-kamp') !== (f.k === 1)) el.classList.toggle('is-kamp', f.k === 1);
      if (el.classList.contains('is-kampiyi') !== (f.kb === 1)) el.classList.toggle('is-kampiyi', f.kb === 1);
    });
    // Club hediyesi içeriği seçili boya göre (18 Eki 2026; snippets/dt-hediye.liquid varyant varyant hesaplar)
    // Kalemler: [{g: görsel, t: "1 × … 1,5 kg"}]; boş dizi → yalnız başlık
    var hm = dtHediyeMap[String(vid)], he = clubEl.querySelector('[data-dt-hediye]');
    if (he && Array.isArray(hm)) {
      var imza = JSON.stringify(hm);
      if (he.getAttribute('data-imza') !== imza) {
        he.setAttribute('data-imza', imza);
        he.textContent = '';
        hm.forEach(function (k) {
          var sat = document.createElement('span'); sat.className = 'pk__h-kalem';
          if (k.g) { var im = document.createElement('img'); im.src = k.g; im.alt = ''; im.width = 44; im.height = 44; im.loading = 'lazy'; sat.appendChild(im); }
          var tx = document.createElement('span'); tx.textContent = k.t || ''; sat.appendChild(tx);
          he.appendChild(sat);
        });
      }
    }
    // Satın alma kartı v2 (31 Eki 2026, onaylı önizleme onizleme-abonelik-2.html): hediye maddesi kısa — kuru mama boyuysa
    // (adında "1,5 kg") "6. siparişte 1,5 kg hediye" + fiyatın altında "hediyeyle 529 TL/kg" (N × abonelik fiyatı ÷ (N × paket kg +
    // hediye kg)); değilse "6. siparişte hediye: 5x <ad>". "Nasıl çalışır?" penceresindeki [data-dt-gift-kisa] aynı kısa metni yazar.
    var gk = clubEl.querySelector('.pk__hediye[data-dt-n]');
    if (gk && Array.isArray(hm)) {
      var gN = parseInt(gk.getAttribute('data-dt-n'), 10) || 0, gKg = 0;
      hm.forEach(function (k) {
        var m = /(\d+(?:[.,]\d+)?)\s*kg\b/i.exec(String(k.a || k.t || ''));
        if (m) gKg += (parseFloat(m[1].replace(',', '.')) || 0) * (Number(k.n) || 1);
      });
      var sayiTr = function (x) { return x.toLocaleString('tr-TR', { maximumFractionDigits: 2 }); };
      var gYer = gk.querySelector('[data-dt-gift]'), gHkg = clubEl.querySelector('[data-dt-hkg]');
      var gKisalar = pd.querySelectorAll('[data-dt-gift-kisa]');
      var gImza = JSON.stringify([hm, kg, f.dc]);
      if (gYer && gYer.getAttribute('data-imza') !== gImza) {
        gYer.setAttribute('data-imza', gImza);
        if (gN > 1 && gKg > 0) {
          var kisa = String(gk.getAttribute('data-k-kg') || 'Her [n]. siparişte [kg] hediye').replace('[n]', gN).replace('[kg]', sayiTr(gKg) + ' kg');
          yaz(gYer, kisa);
          var kisaK = kisa.charAt(0).toLocaleLowerCase('tr-TR') + kisa.slice(1); // pencerede cümle ortası: "…doldur, her 6. siparişte…"
          gKisalar.forEach(function (el) { yaz(el, kisaK); });
          if (gHkg) {
            var ok = kg > 0 && f.dc > 0;
            if (ok) { var tlKg = Math.round(gN * f.dc / 100 / (gN * kg + gKg)); yaz(gHkg.querySelector('strong'), tlKg.toLocaleString('tr-TR') + ' TL/kg'); }
            if (gHkg.hidden !== !ok) gHkg.hidden = !ok;
          }
        } else {
          var adlar = hm.map(function (k) { var n = Number(k.n) || 1; return (n > 1 ? n + 'x ' : '') + (k.a || k.t || ''); }).filter(Boolean).join(', ');
          yaz(gYer, (gk.getAttribute('data-k-bas') || '') + (adlar ? ' ' + adlar : ''));
          if (gHkg && !gHkg.hidden) gHkg.hidden = true;
        }
      }
    }
    // "Ücretsiz kargo" maddesi yalnız abonelik fiyatı ücretsiz kargo eşiğini geçiyorsa (30 Eki: eşiksiz kargo yok)
    var kgo = clubEl.querySelector('[data-dt-kargo]');
    if (kgo && f.dc > 0) { var kh = f.dc < (parseInt(kgo.getAttribute('data-esik'), 10) || 0); if (kgo.hidden !== kh) kgo.hidden = kh; }
    // Hediye Tablosu: seçili boyda hediye seçilmemişse bölüm gizli (19 Eki 2026; club-secim.liquid data-hb)
    if (Array.isArray(hm)) clubEl.querySelectorAll('[data-hb]').forEach(function (el) { el.hidden = !hm.length; });
    // "Her N. siparişte" Club kartı satırı (kural.tumClub; 18 Eki 2026): küçük fotoğraflar, değer (kalemlerin liste değeri), açılan liste
    var cl = clubEl.querySelector('[data-ch-liste]');
    if (cl && Array.isArray(hm)) {
      var cimza = JSON.stringify(hm);
      if (cl.getAttribute('data-imza') !== cimza) {
        cl.setAttribute('data-imza', cimza);
        var th = clubEl.querySelector('[data-ch-th]'), dg = clubEl.querySelector('[data-ch-deger]');
        var para = function (c) { var t = c / 100; return t.toLocaleString('tr-TR', t % 1 ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : {}) + ' TL'; };
        var top = 0;
        cl.textContent = ''; if (th) th.textContent = '';
        hm.forEach(function (k) {
          var f = Number(k.f) || 0; top += f;
          if (th) {
            var t1;
            if (k.g) { t1 = document.createElement('img'); t1.src = k.g; t1.alt = ''; t1.width = 36; t1.height = 36; t1.loading = 'lazy'; } else t1 = document.createElement('span');
            t1.className = 'chk__th'; th.appendChild(t1);
          }
          var sat = document.createElement('span'); sat.className = 'chk__satir';
          var ib = document.createElement('span'); ib.className = 'chk__img';
          if (k.g) { var im2 = document.createElement('img'); im2.src = k.g; im2.alt = ''; im2.width = 44; im2.height = 44; im2.loading = 'lazy'; ib.appendChild(im2); }
          var ad = document.createElement('span'); ad.className = 'chk__ad';
          // 30 Eki 2026 (kullanıcı): adet adın önünde "6x" (1 ise yok); "+1 HEDİYE" etiketi kalktı (snippets/club-hediye-satir ile aynı)
          var adS = document.createElement('span'), nA = Number(k.n) || 1;
          if (nA > 1) { var ax = document.createElement('span'); ax.className = 'chk__adet'; ax.textContent = nA + 'x'; adS.appendChild(ax); adS.appendChild(document.createTextNode(' ')); }
          adS.appendChild(document.createTextNode(k.a || k.t || '')); ad.appendChild(adS);
          var fy = document.createElement('span'); fy.className = 'chk__fiyat';
          if (f > 0) { var s1 = document.createElement('s'); s1.textContent = para(f); fy.appendChild(s1); }
          var b1 = document.createElement('b'); b1.textContent = tt('hediye', 'Hediye'); fy.appendChild(b1);
          sat.appendChild(ib); sat.appendChild(ad); sat.appendChild(fy); cl.appendChild(sat);
        });
        if (dg) { yaz(dg, (dg.getAttribute('data-kalip') || '[t]').replace('[t]', para(top))); if (dg.hidden !== !(top > 0)) dg.hidden = !(top > 0); }
      }
    }
  }
  function dtSecili() {
    var r = clubEl && clubEl.querySelector('[data-dt-radio]:checked');
    return !!(r && r.value === 'duzenli');
  }
  function clubUye() { return !!clubEl && clubEl.getAttribute('data-club-uye') === '1'; }
  // Düğme yazısı seçime göre (13 Eki 2026, rakip gibi): Abonelik → "Abonelik başlat", Tek seferlik → "Sepete ekle".
  // Alt yapışık çubuğun düğmesi de aynı yazıyı alır. (15 Eki: misafir de abonelik başlatır, giriş şart değil.)
  function dugmeYazi() {
    var t = addBtn && addBtn.disabled ? tt('tukendi', 'Tükendi') : (dtSecili() ? tt('abonelik_baslat', 'Abonelik başlat') : tt('sepete_ekle', 'Sepete ekle'));
    if (addText && !addIsleniyor) yaz(addText, t);   // sepete eklenirken "İşleniyor…" kalır
    var sy = document.querySelector('[data-pd-sticky-yazi]'); if (sy) yaz(sy, t);
  }
  // Fiyatlar kartların kendi içinde (Abonelik kartı / Tek seferlik kartı); burada yalnız taksit tablosu, alt çubuk fiyatı
  // ve düğme yazısı seçime göre güncellenir.
  function clubAnaFiyat() {
    var vid = idInput ? idInput.value : '';
    var f = clubMap[String(vid)];
    var dt = dtSecili();
    if (f) currentPriceCents = dt ? f.dc : f.nc;
    var sf = document.querySelector('[data-pd-sticky-fiyat]');
    if (sf) yaz(sf, dt && f ? f.d : (nowEl ? nowEl.textContent : sf.textContent));
    dugmeYazi();
    // Taksit tablosu (toLocaleString'li 7 satır) çizimden sonra (INP, 17 Eki 2026)
    boyaSonra(function () { if (typeof tYaz === 'function') tYaz(); });
  }
  if (clubEl) clubEl.addEventListener('change', function (e) {
    // Teslimat sıklığı değişince "Düzenli teslimat" seçilir
    if (e.target.matches('[data-duzenli-hafta]')) {
      var dr = clubEl.querySelector('[data-dt-radio][value="duzenli"]'); if (dr && !dr.checked && !dr.disabled) dr.checked = true;
    }
    if (e.target.matches('[data-dt-radio], [data-duzenli-hafta]')) clubAnaFiyat();
  });

  // "Petidi Club'a katıl" işaretliyse ve üye değilse sepete eklenecek üyelik varyantı (sepette zaten varsa eklenmez)
  function clubEklenecek() {
    if (!clubEl || clubUye()) return 0;
    var c = clubEl.querySelector('[data-club-check]');
    return c && c.checked ? Number(clubEl.getAttribute('data-club-vid')) || 0 : 0;
  }

  // Seçilen kg ekran okuyucuya bir kez duyurulur (16 Eki 2026; main-product [data-pd-duyuru], aria-live="polite")
  var duyuruEl = pd.querySelector('[data-pd-duyuru]');
  var secimSira = 0;
  function selectVariant(btn) {
    var d = btn.dataset;
    var vid = btn.getAttribute('data-variant-id');
    var sira = ++secimSira;
    // INP (17 Eki 2026): bu fonksiyon iki adım. 1) HEMEN (dokunuşla aynı karede çizilir): seçim işareti, gizli input, fiyatlar,
    // abonelik kartı fiyatları, düğme. 2) ÇİZİMDEN SONRA (boyaSonra): adres, karşılaştırma kartı, puan/taksit/kargo/SKT/stok
    // satırları, geri sayım. Davranış aynı; yalnız sıra. Metinler yaz() ile (düğüm eklemeden) → Shopify'ın sayfa gözlemcileri
    // her tıklamada tüm sayfayı taramıyor. Hızlı art arda basışta yalnız son seçimin 2. adımı çalışır.
    if (idInput) idInput.value = vid;
    pd.querySelectorAll('[data-variant-id]').forEach(function (b) {
      var sel = b === btn;
      if (b.classList.contains('is-selected') !== sel) b.classList.toggle('is-selected', sel);
      if (b.getAttribute('aria-pressed') !== (sel ? 'true' : 'false')) b.setAttribute('aria-pressed', sel ? 'true' : 'false');
    });
    var boyAd = pd.querySelector('[data-pd-boyad]'); if (boyAd && d.boy) yaz(boyAd, d.boy);

    // Fiyat
    if (nowEl && d.price) yaz(nowEl, d.price);
    var stkF = document.querySelector('[data-pd-sticky-fiyat]'); if (stkF && d.price) yaz(stkF, d.price);
    if (unitEl) { if (d.unitprice) { yaz(unitEl, '(' + d.unitprice + ' / Kg)'); unitEl.hidden = false; } else unitEl.hidden = true; }
    if (compareEl) { if (d.compare) { yaz(compareEl, d.compare); compareEl.hidden = false; } else compareEl.hidden = true; }
    if (badgeEl) { if (d.badge) { yaz(badgeEl, d.badge); badgeEl.hidden = false; } else badgeEl.hidden = true; }
    if (saveEl) { if (d.save) { yaz(saveEl, d.save); saveEl.hidden = false; } else saveEl.hidden = true; }

    // Sepete Ekle hediye id'leri (Club hediyeleri kapalıyken eski düzen) — düğme hemen basılabilir, bu yüzden 1. adımda
    if (addBtn && btn.hasAttribute('data-giftids')) addBtn.setAttribute('data-giftids', btn.getAttribute('data-giftids') || '');
    clubFiyat(vid);

    // Stok / sepete ekle
    var avail = d.available === '1';
    var preorder = d.preorder === '1';
    if (addBtn) addBtn.disabled = !avail;
    haberGoster(avail);
    var adetEl = pd.querySelector('[data-pd-adet]');
    if (adetEl && adetEl.hidden !== !avail) adetEl.hidden = !avail;
    currentPreorder = preorder;
    if (d.pricecents) currentPriceCents = Number(d.pricecents) || currentPriceCents;
    if (dtSecili()) clubAnaFiyat(); else dugmeYazi();   // abonelikte alt çubuk fiyatı + düğme yazısı; taksit tablosu 2. adımda

    boyaSonra(function () {
      if (sira !== secimSira) return;   // arada başka boy seçildi; onun 2. adımı çalışacak
      // Adres de seçili varyantı göstersin (16 Eki 2026): kopyalanan bağlantı aynı kg'yi açar. Diğer parametreler korunur;
      // replaceState → geri tuşu her kg için ayrı adım olmaz. Canonical Liquid'de, etkilenmez. (Shopify'ın web pixel
      // yöneticisi replaceState'i dinleyip olay yayınlıyor — tıklama karesinde ~20 ms; bu yüzden çizimden sonra.)
      // Kendi görevinde (araya tarayıcı girebilsin; 2. adım tek uzun görev olmasın)
      setTimeout(function () { if (sira !== secimSira) return; try { var su = new URL(location.href); su.searchParams.set('variant', vid); history.replaceState(history.state, '', su.toString()); } catch (e) {} }, 0);
      // Karşılaştırmanın "Bu ürün" kartı seçili kg'yi göstersin (urun-karsilastir, card-product secili)
      var kb = document.querySelector('.kr__bu .pcard');
      if (kb) {
        var kt = kb.querySelector('.pcard__title'), kp = kb.querySelector('.pcard__price'), kf = kb.querySelector('.pcard__kgf'), ko = kb.querySelector('.pcard__vold'), kv = kb.querySelector('[data-card-variant]');
        if (kt && d.boy) { var son = kt.lastChild; if (son && son.nodeType === 3 && /, [^,]*$/.test(son.nodeValue)) son.nodeValue = son.nodeValue.replace(/, [^,]*$/, ', ' + d.boy); }
        if (kp && d.price) kp.innerHTML = d.price.replace(/\s*TL$/, '') + '<sup>TL</sup>';
        if (kf) { kf.textContent = d.unitprice ? '(' + d.unitprice.replace(/\s*TL$/, ' TL') + '/kg)' : ''; kf.hidden = !d.unitprice; }
        if (ko) { ko.textContent = d.compare || ''; ko.hidden = !d.compare; }
        if (kv) kv.setAttribute('data-variant-id', vid);
        kb.querySelectorAll('a[href*="/products/"]').forEach(function (a) { try { var au = new URL(a.href, location.href); au.searchParams.set('variant', vid); a.href = au.pathname + au.search; } catch (e) {} });
      }
      if (duyuruEl) {
        var dy = [d.boy || '', d.price || '', d.available === '1' ? (d.preorder === '1' ? tt('on_siparis', 'ön sipariş') : tt('stokta_k', 'stokta')) : tt('tukendi_k', 'tükendi')].filter(Boolean).join(', ');
        duyuruEl.textContent = ''; setTimeout(function () { duyuruEl.textContent = dy; }, 60);
      }

      // Sepet indirimi: not + geri sayım seçili varyanta göre yeniden kurulur
      var indVar = d.disc === '1';
      indirimNotu(indVar, d.cdname || '');
      cdKur(indVar ? (d.cdend || '') : '', d.cdname || '');

      // Puan + taksit + kargo
      if (puanEl && d.puan) yaz(puanEl, d.puan);
      if (puanHEl && d.puanh) yaz(puanHEl, d.puanh);   // havale puanı da varyanta bağlı
      if (taksitEl && d.taksit) yaz(taksitEl, d.taksit);
      if (freeshipEl && d.net) { fsNet = +d.net || 0; fsRender(); }
      if (installmentEl && d.taksitok !== undefined) installmentEl.hidden = d.taksitok !== '1';

      // Hediyeler: seçili varyantınkini göster
      pd.querySelectorAll('[data-gifts-for]').forEach(function (g) {
        g.hidden = g.getAttribute('data-gifts-for') !== String(vid);
      });

      // Bilgi kartındaki ağırlık / barkod / stok kodu satırları (varyanta göre değişir)
      Object.keys(pinfoRows).forEach(function (key) {
        var cell = pinfoRows[key];
        if (!cell) return;
        var row = cell.closest('.pinfo__row');
        var val = d[key];
        if (val) {
          yaz(cell, val);
          if (row) row.hidden = false;
        } else if (row) {
          row.hidden = true;
        }
      });

      // SKT — tarih yoksa tazelik taahhüdü metnine düş
      if (sktWrap && sktEl) {
        var sktVal = d.skt || sktFallback;
        if (sktVal) {
          yaz(sktEl, sktVal);
          if (sktLabel) sktLabel.hidden = !d.skt;
          if (sktIco) sktIco.hidden = !!d.skt;
          sktWrap.classList.toggle('is-guarantee', !d.skt);
          sktWrap.hidden = false;
        } else {
          sktWrap.hidden = true;
        }
      }

      // Kargo mesajını ön sipariş durumuna göre güncelle
      if (renderShipFn) renderShipFn();

      // Taksit tablosu (seçili boyun fiyatı; abonelikte ilk sipariş fiyatı — clubAnaFiyat currentPriceCents'i ayarladı)
      if (typeof tYaz === 'function') tYaz();

      // Düşük stok mesajı
      if (lowStockEl) {
        var inv = Number(d.inventory);
        var thr = Number(lowStockEl.getAttribute('data-threshold')) || 0;
        if (inv > 0 && thr > 0 && inv <= thr) {
          var strong = lowStockEl.querySelector('strong');
          if (strong) yaz(strong, inv);
          lowStockEl.hidden = false;
        } else {
          lowStockEl.hidden = true;
        }
      }
    });
  }

  if (cdEl) cdKur(cdEl.getAttribute('data-pd-countdown') || '', '');
  if (clubEl && idInput) clubFiyat(idInput.value);   // abonelik kg fiyatları açılışta da
  if (clubEl) clubAnaFiyat();   // varsayılan seçim Abonelik → düğme yazısı, alt çubuk fiyatı

  pd.querySelectorAll('[data-variant-id]').forEach(function (btn) {
    btn.addEventListener('click', function () { selectVariant(btn); });
  });

  // ---- Miktar ----
  var qtyInput = pd.querySelector('[data-qty-input]');
  function stepQty(d) {
    if (!qtyInput) return;
    var val = parseInt(qtyInput.value, 10) || 1;
    val = Math.max(1, val + d);
    qtyInput.value = val;
  }
  var minus = pd.querySelector('[data-qty-minus]');
  var plus = pd.querySelector('[data-qty-plus]');
  if (minus) minus.addEventListener('click', function () { stepQty(-1); });
  if (plus) plus.addEventListener('click', function () { stepQty(1); });

  // ---- Yaş mamada aboneliğe en az adet (30 Eki 2026, kullanıcı: tekli konserve/pouch'ta abonelik yok; snippets/club-secim
  // data-dt-min, tema ayarı club_duzenli_yas_min). Adet < min: Düzenli teslimat gizli + kapalı, not görünür; Düzenli seçiliyse
  // Tek seferliğe döner. Adet min'e çıkınca (liste, +/−, paket varyantı 12'li/24'lü) açılır. data-dt-min yoksa (kuru mama) hiçbir şey yapmaz.
  var dtMinFs = clubEl && clubEl.querySelector('.pk__secim[data-dt-min]');
  if (dtMinFs) dtMinFs.addEventListener('change', function (e) { if (e.isTrusted && e.target.matches('[data-dt-radio]')) dtElleSecildi = true; });
  // Paket varyantı (Shopify varyant paketi, 30 Eki 2026: "12x85 GR" tekliye bağlı) — içindeki adet; Liquid karşılığı snippets/paket-carpan
  function paketCarpan() {
    var b = pd.querySelector('.pd__variant.is-selected[data-boy]');
    var m = b && /^\s*(\d+)\s*x/i.exec(b.getAttribute('data-boy') || '');
    return m && +m[1] > 1 ? +m[1] : 1;
  }
  var dtElleSecildi = false;
  function dtMinUygula() {
    if (!dtMinFs) return;
    var min = parseInt(dtMinFs.getAttribute('data-dt-min'), 10) || 0;
    var q = (qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1) * paketCarpan();
    var kapali = min > 1 && q < min;
    var opt = dtMinFs.querySelector('[data-dt-opt]');
    var dr = dtMinFs.querySelector('[data-dt-radio][value="duzenli"]');
    var tr = dtMinFs.querySelector('[data-dt-radio][value="tek"]');
    var degisti = false;
    if (kapali && dr && dr.checked && tr) { tr.checked = true; degisti = true; }
    // Açılınca varsayılan Abonelik (31 Eki 2026 kartı) — müşteri kendisi seçim yapmadıysa
    if (!kapali && dr && dr.disabled && !dtElleSecildi) { dr.disabled = false; dr.checked = true; degisti = true; }
    if (dtMinFs.classList.contains('is-dt-kapali') !== kapali) dtMinFs.classList.toggle('is-dt-kapali', kapali);
    if (opt && opt.hidden !== kapali) opt.hidden = kapali;
    if (dr && dr.disabled !== kapali) dr.disabled = kapali;
    if (degisti) clubAnaFiyat();
  }
  if (dtMinFs) {
    if (qtyInput) qtyInput.addEventListener('change', dtMinUygula);
    if (minus) minus.addEventListener('click', dtMinUygula);
    if (plus) plus.addEventListener('click', dtMinUygula);
    pd.querySelectorAll('[data-variant-id]').forEach(function (b) { b.addEventListener('click', dtMinUygula); });   // paket varyantı (12x85 GR)
    dtMinUygula();
  }

  // ---- A/B yaşam görseli → sepet özelliği (31 Eki 2026, kullanıcı onayı: "her siparişin grubunu bilelim", izinsiz dahil) ----
  // Testteki ürün sayfasının kendi düğmesiyle ekleme BAŞARILI olunca, sepette `_ab_yasam` yoksa bir kez /cart/update.js
  // { attributes: { _ab_yasam: 'A'|'B' } } (alt çizgili → ödemede görünmez; siparişin note_attributes'ına geçer; yalnız grup harfi).
  // Ajax update.js yalnız verilen anahtarı değiştirir (Fatura Tipi, _davet, Pet Profili kalır). İlk değer kalır: sayfa açılışında
  // sepette varsa (Liquid data-ab-sepet) ya da bu sepet tokeni için zaten yazıldıysa (localStorage petidi_ab_sepet) istek yok.
  // Ekleme akışını beklemez/bozmaz (keepalive: abonelikte /cart'a geçilse de gider). 429'da en çok 2 kez geri çekilip tekrar;
  // başarısızsa ziyaretçi pikseline 'ab_hata' (izin kurallarına tabi). Rapor: ahtapot › Analiz › A/B Testleri.
  function abYasamSepet() {
    var bildir = function (d) { try { document.dispatchEvent(new CustomEvent('petidi:ab-hata', { detail: { d: String(d).slice(0, 80) } })); } catch (e) {} };
    try {
      var tr = pd.querySelector('.pd__gtrack--ab');
      if (!tr || tr.getAttribute('data-ab-sepet')) return;
      var c = document.documentElement.classList;
      if (c.contains('ab-yasam-hata')) return;
      var g = c.contains('ab-yasam-a') ? 'A' : c.contains('ab-yasam-b') ? 'B' : '';
      if (!g) return;
      var tokOku = function (t) { try { return decodeURIComponent(String(t || '')).split('?')[0]; } catch (e) { return ''; } };
      var tok = tokOku((document.cookie.match(/(?:^|; )cart=([^;]*)/) || [])[1]);
      try { if (tok && localStorage.getItem('petidi_ab_sepet') === tok) { tr.setAttribute('data-ab-sepet', g); return; } } catch (e) {}
      tr.setAttribute('data-ab-sepet', g);   // aynı sayfada ikinci eklemede tekrar istek yok
      var dene = function (n) {
        return fetch((window.PETIDI_KOK || '') + '/cart/update.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _ab_yasam: g } }) })
          .then(function (r) {
            if (r.status === 429 && n < 2) return new Promise(function (ok) { setTimeout(ok, 1500 * Math.pow(2, n)); }).then(function () { return dene(n + 1); });
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json().then(function (cart) { try { localStorage.setItem('petidi_ab_sepet', tokOku((cart && cart.token) || tok)); } catch (e) {} });
          });
      };
      dene(0).catch(function (e) { tr.removeAttribute('data-ab-sepet'); bildir('sepet özelliği yazılamadı: ' + ((e && e.message) || e)); });
    } catch (e) { bildir('sepet özelliği: ' + ((e && e.message) || e)); }
  }

  // ---- Galeri slider ----
  var track = pd.querySelector('[data-gallery-track]');
  // A/B yaşam görseli (31 Eki 2026): A grubunda yaşam slaydı CSS order:-1 ile ilk sırada, DOM'da 2. → bütün indeksler
  // GÖRSEL sıraya göre (order, sonra DOM sırası). Test yokken order hep 0 → DOM sırasıyla aynı.
  function gorselSira(list) {
    return Array.prototype.map.call(list, function (el, i) { return { el: el, i: i, o: parseInt(getComputedStyle(el).order, 10) || 0 }; })
      .sort(function (a, b) { return a.o - b.o || a.i - b.i; }).map(function (x) { return x.el; });
  }
  if (track) {
    var slideEls = gorselSira(track.children);
    var slides = slideEls.length;
    var idx = 0;
    var curEl = pd.querySelector('[data-gallery-current]');
    var thumbs = gorselSira(pd.querySelectorAll('[data-thumb]'));
    function thumbYaz(kaydir) {
      thumbs.forEach(function (t, k) {
        var on = k === idx;
        t.classList.toggle('is-active', on);
        if (on) { t.setAttribute('aria-current', 'true'); if (kaydir) t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
        else t.removeAttribute('aria-current');
      });
    }
    function go(i) {
      idx = (i + slides) % slides;
      track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      if (curEl) curEl.textContent = idx + 1;
      thumbYaz(true);
    }
    if (track.classList.contains('pd__gtrack--ab')) thumbYaz(false);   // A'da ilk küçük resim yaşam görseli (Liquid DOM'un ilkini işaretledi)
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var gp = pd.querySelector('[data-gallery-prev]');
    var gn = pd.querySelector('[data-gallery-next]');
    if (gp) gp.addEventListener('click', function () { go(idx - 1); });
    if (gn) gn.addEventListener('click', function () { go(idx + 1); });
    // dokunmatik kaydırma
    var sx = 0, dx = 0, drag = false;
    track.addEventListener('touchstart', function (e) { drag = true; sx = e.touches[0].clientX; dx = 0; }, { passive: true });
    track.addEventListener('touchmove', function (e) { if (drag) dx = e.touches[0].clientX - sx; }, { passive: true });
    track.addEventListener('touchend', function () { if (drag && Math.abs(dx) > 40) { dx < 0 ? go(idx + 1) : go(idx - 1); } drag = false; });

    // ---- Tam ekran görsel (UX denetimi #9) ----
    // Görsele dokun / büyüteç → tam ekran. Yanlara kaydır, çift dokun/çift tıkla = 2.5x yakınlaştır
    // (dokunulan noktaya), tekrar = geri. Tarayıcı "Geri" kapatır (history.pushState). Büyük görsel
    // (2000px) yalnız açılınca yüklenir.
    var lb = pd.querySelector('[data-lb]');
    if (lb) {
      // body'ye taşı: masaüstünde .pd__gallery sticky → kendi katmanı (stacking context); pencere onun
      // içinde kalınca sağ kolon (boyutlar, yıldızlar, öneriler) üstüne çıkıyordu (7 Ekim, kullanıcı ekranı).
      // Aroma geçişinde (sayfa yenilenmeden) önceki ürünün penceresi body'de kalmasın
      document.querySelectorAll('body > [data-lb]').forEach(function (x) { if (x !== lb) x.remove(); });
      document.body.appendChild(lb);
      var lbTrack = lb.querySelector('[data-lb-track]');
      var lbSlides = gorselSira(lbTrack.children);   // kaydırma konumu görsel sırada; dizi de öyle (yakınlaştırma dinleyicileri)
      var lbCount = lb.querySelector('[data-lb-count]');
      var lbHint = lb.querySelector('[data-lb-hint]');
      var lbOpen = false, lbIdx = 0, scrollY0 = 0;
      function lbCur() { return Math.round(lbTrack.scrollLeft / Math.max(1, lbTrack.clientWidth)); }
      function lbShow(i) {
        lbIdx = Math.max(0, Math.min(lbSlides.length - 1, i));
        lbTrack.scrollTo({ left: lbIdx * lbTrack.clientWidth, behavior: 'auto' });
        if (lbCount) lbCount.textContent = (lbIdx + 1) + '/' + lbSlides.length;
      }
      function unzoom() {
        for (var k = 0; k < lbSlides.length; k++) lbSlides[k].classList.remove('is-zoom');
        lb.classList.remove('is-zoomed');
      }
      function openLb(i) {
        if (lbOpen) return;
        lb.querySelectorAll('img[data-src]').forEach(function (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); });
        lbOpen = true; scrollY0 = window.scrollY;
        lb.hidden = false; document.body.style.overflow = 'hidden';
        lbShow(i);
        try { history.pushState({ petidiLb: 1 }, ''); } catch (e) {}
        if (lbHint) { lbHint.classList.remove('is-gone'); setTimeout(function () { lbHint.classList.add('is-gone'); }, 2500); }
        var x = lb.querySelector('[data-lb-close]'); if (x) x.focus({ preventScroll: true });
      }
      function closeLb(fromPop) {
        if (!lbOpen) return;
        lbOpen = false; unzoom();
        lb.hidden = true; document.body.style.overflow = '';
        window.scrollTo(0, scrollY0);
        go(lbIdx);
        if (!fromPop && history.state && history.state.petidiLb) history.back();
      }
      window.addEventListener('popstate', function () { if (lbOpen) closeLb(true); }, sig);
      lb.querySelector('[data-lb-close]').addEventListener('click', function () { closeLb(false); });
      var lp = lb.querySelector('[data-lb-prev]'), ln = lb.querySelector('[data-lb-next]');
      if (lp) lp.addEventListener('click', function () { unzoom(); lbShow(lbCur() - 1); });
      if (ln) ln.addEventListener('click', function () { unzoom(); lbShow(lbCur() + 1); });
      lbTrack.addEventListener('scroll', function () { if (lbCount) lbCount.textContent = (lbCur() + 1) + '/' + lbSlides.length; }, { passive: true });
      document.addEventListener('keydown', function (e) {
        if (!lbOpen) return;
        if (e.key === 'Escape') closeLb(false);
        else if (e.key === 'ArrowRight') { unzoom(); lbShow(lbCur() + 1); }
        else if (e.key === 'ArrowLeft') { unzoom(); lbShow(lbCur() - 1); }
      }, sig);
      function toggleZoom(slide, cx, cy) {
        var img = slide.querySelector('img');
        if (slide.classList.contains('is-zoom')) { unzoom(); return; }
        var r = img.getBoundingClientRect();
        var fx = (cx - r.left) / r.width, fy = (cy - r.top) / r.height;
        slide.classList.add('is-zoom'); lb.classList.add('is-zoomed');
        requestAnimationFrame(function () {
          slide.scrollLeft = fx * slide.scrollWidth - slide.clientWidth / 2;
          slide.scrollTop = fy * slide.scrollHeight - slide.clientHeight / 2;
        });
      }
      var lastTap = 0;
      for (var k2 = 0; k2 < lbSlides.length; k2++) (function (slide) {
        slide.addEventListener('dblclick', function (e) { toggleZoom(slide, e.clientX, e.clientY); });
        slide.addEventListener('touchend', function (e) {
          if (e.changedTouches.length !== 1 || e.touches.length) return;
          var t = Date.now();
          if (t - lastTap < 300) { e.preventDefault(); var p = e.changedTouches[0]; toggleZoom(slide, p.clientX, p.clientY); lastTap = 0; }
          else lastTap = t;
        });
      })(lbSlides[k2]);
      // Galeriden açılış: dokunma (kaydırma değilse) ya da büyüteç
      // Masaüstünde galeri kolaj (tüm fotoğraflar görünür) → tıklanan fotoğrafı aç; mobilde o anki slayt
      track.addEventListener('click', function (e) {
        if (Math.abs(dx) >= 10) return;
        var sl = e.target.closest && e.target.closest('.pd__slide');
        var k = sl ? slideEls.indexOf(sl) : -1;
        openLb(k >= 0 && window.matchMedia('(min-width: 750px)').matches ? k : idx);
      });
      var zb = pd.querySelector('[data-lb-open]');
      if (zb) zb.addEventListener('click', function () { openLb(idx); });
    }
  }

  // ---- Yetkili satıcı modalı ----
  var modal = pd.querySelector('[data-auth-modal]');
  var openBtns = pd.querySelectorAll('[data-auth-open]');   // başlık üstü + mobilde fotoğraf şeridi
  var openBtn = openBtns[0];
  if (modal && openBtn) {
    function openModal() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function closeModal() { modal.hidden = true; document.body.style.overflow = ''; }
    openBtns.forEach(function (b) { b.addEventListener('click', openModal); });
    modal.querySelectorAll('[data-auth-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); }, sig);
  } else if (openBtn && !modal) {
    openBtns.forEach(function (b) { b.style.display = 'none'; });
  }

  // ---- Kargo zamanlaması (hafta içi 15:00, Cumartesi 12:00 kesimi, Türkiye saati) ----
  var shipEl = pd.querySelector('[data-pd-shipping]');
  if (shipEl) {
    if (shipEl.getAttribute('data-preorder') === '1') currentPreorder = true;
    var preDays = parseInt(shipEl.getAttribute('data-preorder-days'), 10);
    if (!(preDays > 0)) preDays = 3;
    var TZ = 'Europe/Istanbul';
    function nowTZ() { return new Date(new Date().toLocaleString('en-US', { timeZone: TZ })); }
    // Resmî tatiller: tema ayarı "kargo_tatil" → window.PETIDI_TATIL (theme.liquid). "2026-10-29" = kargo yok;
    // "2026-10-28 12:00" = yarım gün, kesim 12:00. Cumartesi 12:00'ye kadar kargo çıkıyor (kullanıcı, 9 Ekim 2026), Pazar yok. (UX denetimi #10)
    var TATIL = {};
    (window.PETIDI_TATIL || []).forEach(function (l) {
      var p = String(l).trim().split(/\s+/);
      if (/^\d{4}-\d{2}-\d{2}$/.test(p[0])) TATIL[p[0]] = p[1] ? parseInt(p[1], 10) || 0 : 0;
    });
    function ymd(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
    function isWork(d) { if (d.getDay() === 0) return false; var t = TATIL[ymd(d)]; return t === undefined || t > 0; }
    function kesim(d) { var x = new Date(d), t = TATIL[ymd(d)]; x.setHours(t > 0 ? t : (d.getDay() === 6 ? 12 : 15), 0, 0, 0); return x; }   // hafta içi kesim 15:00 (kullanıcı, 2 Kas 2026; önce 14:00)
    // Kalan süreyi yazıya çevirir. SIFIR OLAN BİRİMİ YAZMAZ: "0 saat 25 dakika"
    // yerine "25 dakika", "2 gün 0 saat" yerine "2 gün". Son bir dakika kalmışsa
    // "0 dakika" demektense yukarı yuvarlayıp "1 dakika" der.
    function sureMetni(mins) {
      var h = Math.floor(mins / 60), m = mins % 60, p = [];
      if (h >= 24) {
        p.push(tt('n_gun', '[n] gün', { n: Math.floor(h / 24) }));
        if (h % 24) p.push(tt('n_saat', '[n] saat', { n: h % 24 }));
      } else {
        if (h) p.push(tt('n_saat', '[n] saat', { n: h }));
        if (m) p.push(tt('n_dakika', '[n] dakika', { n: m }));
      }
      return p.length ? p.join(' ') : tt('n_dakika', '[n] dakika', { n: 1 });
    }
    var notEl = pd.querySelector('[data-pd-kargonot]');
    function gunFark(a, b) { return Math.round((new Date(a.getFullYear(), a.getMonth(), a.getDate()) - new Date(b.getFullYear(), b.getMonth(), b.getDate())) / 864e5); }
    // Teslimat kutusu (24 Eki 2026): başlık "Hızlı Teslimat · Yurtiçi Kargo" + küçük gri "19 saat içinde sipariş ver";
    // altında zaman çizgisi Bugün Sipariş → [Bugün/Yarın/Pazartesi] Kargoda → [gün] [tarih] kapında.
    // Ön siparişte başlık "Ön sipariş", orta adım "3 iş günü / içinde kargoda".
    var tlKargo = pd.querySelector('[data-pd-tl-kargo]'), tlKargoAlt = pd.querySelector('[data-pd-tl-kargo-alt]');
    function baslikYaz(on) {
      shipEl.innerHTML = (on ? '<span class="pd-tes__on">' + tt('tl_onsiparis', 'Ön sipariş') : '<span class="pd-tes__hizli">' + tt('tl_hizli', 'Hızlı Teslimat')) +
        '</span> · Yurtiçi Kargo';
    }
    function renderShip() {
      var now = nowTZ();
      // Ön sipariş: N iş günü içinde kargolanır. N markaya göre değişir (tema ayarı),
      // Liquid hesaplayıp data-preorder-days ile veriyor; okunamazsa 3'e düşülür.
      if (currentPreorder) {
        var pdN = new Date(now), added = 0;
        while (added < preDays) { pdN.setDate(pdN.getDate() + 1); if (isWork(pdN)) added++; }
        baslikYaz(true);
        if (tlKargo) tlKargo.textContent = tt('tl_is_gunu' + (preDays === 1 ? '.one' : '.other'), '[n] iş günü', { n: preDays });
        if (tlKargoAlt) tlKargoAlt.textContent = tt('tl_icinde_kargoda', 'içinde kargoda');
        if (notEl) { notEl.textContent = ''; notEl.hidden = true; }
        etaYaz(pdN);
        return;
      }
      var deadline;
      var cutoffToday = kesim(now);
      if (isWork(now) && now < cutoffToday) {
        deadline = cutoffToday;
      } else {
        var d = new Date(now);
        do { d.setDate(d.getDate() + 1); } while (!isWork(d));
        deadline = kesim(d);
      }
      var diff = deadline - now; if (diff < 0) diff = 0;
      // Kısa yazım (satır tek kalsın): 1 saatten fazlaysa yalnız saat ("20 saat"), 24 saati geçerse gün; altında dakika
      var dkK = Math.floor(diff / 60000);
      var kisa = dkK >= 1440 ? tt('n_gun', '[n] gün', { n: Math.floor(dkK / 1440) }) : (dkK >= 60 ? tt('n_saat', '[n] saat', { n: Math.floor(dkK / 60) }) : sureMetni(dkK));
      var fark = gunFark(deadline, now);
      var gunAd = tt('gunler', 'Pazar,Pazartesi,Salı,Çarşamba,Perşembe,Cuma,Cumartesi').split(',');
      baslikYaz(false);
      if (tlKargo) tlKargo.textContent = fark <= 0 ? tt('tl_bugun', 'Bugün') : fark === 1 ? tt('tl_yarin', 'Yarın') : gunAd[deadline.getDay()];
      if (tlKargoAlt) tlKargoAlt.textContent = tt('tl_kargoda', 'Kargoda');
      if (notEl) { notEl.textContent = tt('siparis_ver', '[n] içinde sipariş ver', { n: kisa }); notEl.hidden = false; }
      etaYaz(deadline);
    }
    // Tahmini teslim — İL BAZINDA (9 Ekim 2026). Tablo gerçek gönderilerden: 23 Tem–9 Eki 190 Yurtiçi gönderisi
    // (Shopify kargoya veriliş → "teslim edildi" olayı, ahtapot kargo kayıtlarındaki il). Genel: %76 ertesi iş günü,
    // %95 en geç 2, hiçbiri 3'ü geçmedi. ≥2 gönderisi olan ilde en sık süre (eşitlikte uzun olan); verisi az/yok
    // ilde bölge varsayılanı (Marmara/Ege 1, İç Anadolu/Akdeniz/Karadeniz 2, Doğu/Güneydoğu 3), az veri bölgeyi
    // yalnız uzatabilir. Yurtiçi Cumartesi de dağıtıyor → teslimde Cumartesi sayılır, Pazar ve tatil sayılmaz.
    // İl: ziyaretçinin seçtiği (localStorage) > giriş yapmış müşterinin adresi (data-musteri-il) > IP (ahtapot /acik/il).
    // İl bilinmiyorsa aralık 1–2 iş günü (gönderilerin %95'i). Ayrıntı: docs/ux-denetim.md #7.
    var IL_GUN = window.PETIDI_IL_GUN || {};   // tablo theme.liquid'de (kart/sepet de aynısını kullanır)
    var IL_ADLAR = Object.keys(IL_GUN).sort(function (a, b) { return a.localeCompare(b, 'tr'); });
    var etaEl = pd.querySelector('[data-pd-eta]'), tlEta = pd.querySelector('[data-pd-tl-eta]');
    var ayAd = tt('aylar', 'Ocak,Şubat,Mart,Nisan,Mayıs,Haziran,Temmuz,Ağustos,Eylül,Ekim,Kasım,Aralık').split(',');
    function ilKey(t) { return String(t || '').toLocaleLowerCase('tr').replace(/i̇/g, 'i'); }
    var IL_ARA = IL_ADLAR.map(function (a) { return [ilKey(a), a]; })
      .concat([['istanbul', 'İstanbul'], ['izmir', 'İzmir'], ['afyon', 'Afyonkarahisar'], ['k.maraş', 'Kahramanmaraş'], ['maras', 'Kahramanmaraş']]);
    // "İSTANBUL / GÜNGÖREN", "Merkez/Kastamonu", "Izmir" → il adı; tanınmazsa null.
    function ilBul(t) {
      var k = ilKey(t).replace(/ı/g, 'i'), en = null;
      IL_ARA.forEach(function (x) { var a = x[0].replace(/ı/g, 'i'); if (k.indexOf(a) >= 0 && (!en || a.length > en[0].length)) en = [a, x[1]]; });
      return en ? en[1] : null;
    }
    function ilOku() { try { return localStorage.getItem('petidi_il'); } catch (e) { return null; } }
    function ilYaz(v) { try { v ? localStorage.setItem('petidi_il', v) : localStorage.removeItem('petidi_il'); } catch (e) {} }
    // Giriş yapmış müşterinin varsayılan adresi: data-musteri-il="il|ilçe" (province|city). İl tanınmazsa ilçe alanından aranır.
    var mParca = String((etaEl && etaEl.getAttribute('data-musteri-il')) || '').split('|');
    var musteriIl = ilBul(mParca[0]) || ilBul(mParca[1] || '') || null;
    var musteriIlce = (function (c) {
      c = String(c || '').trim();
      if (!c || !musteriIl || ilKey(c) === ilKey(musteriIl) || ilBul(c) === musteriIl && ilKey(c).length <= ilKey(musteriIl).length + 2) return '';
      // "TEPEBAŞI" → "Tepebaşı" (adres büyük harfle yazılmışsa)
      if (c === c.toLocaleUpperCase('tr')) c = c.toLocaleLowerCase('tr').replace(/(^|[\s\/-])(\S)/g, function (m, a, h) { return a + h.toLocaleUpperCase('tr'); });
      return c;
    })(mParca[1]);
    // İl önceliği: ziyaretçinin seçtiği > giriş yapmış müşterinin adresi > IP tahmini (ahtapot /acik/il, Cloudflare).
    var secilenIl = (function () { var s = ilOku(); return IL_GUN[s] ? s : musteriIl; })();
    function teslimGunu(d) { var w = d.getDay(); if (w === 0) return false; var t = TATIL[ymd(d)]; return t === undefined || t > 0; }
    function teslimEkle(d, n) { var x = new Date(d), k = 0; while (k < n) { x.setDate(x.getDate() + 1); if (teslimGunu(x)) k++; } return x; }
    var sonKargoGunu = null;
    var ayK = tt('aylar_kisa', 'Oca,Şub,Mar,Nis,May,Haz,Tem,Ağu,Eyl,Eki,Kas,Ara').split(',');
    var gunK = tt('gunler_kisa', 'Paz,Pzt,Sal,Çar,Per,Cum,Cmt').split(',');
    var gunT = tt('gunler', 'Pazar,Pazartesi,Salı,Çarşamba,Perşembe,Cuma,Cumartesi').split(',');
    // Teslimat adresi hapı: "ilçe, il" (yalnız müşterinin kendi ilindeyken) / "il" / "İl seç"
    var adresEl = pd.querySelector('[data-pd-adres]');
    var ilSecEl = pd.querySelector('[data-pd-il-sec]');
    function adresYaz() {
      if (!adresEl) return;
      adresEl.textContent = secilenIl ? (musteriIlce && secilenIl === musteriIl ? musteriIlce + ', ' + secilenIl : secilenIl) : tt('il_sec_hap', 'İl seç');
      if (ilSecEl) ilSecEl.value = secilenIl || '';
    }
    if (ilSecEl) {
      ilSecEl.innerHTML = '<option value="">' + tt('il_sec', 'İl seç…') + '</option>' + IL_ADLAR.map(function (a) { return '<option>' + a + '</option>'; }).join('');
      ilSecEl.addEventListener('change', function () {
        if (!ilSecEl.value) { adresYaz(); return; }
        secilenIl = ilSecEl.value; ilYaz(secilenIl); etaYaz();
        if (window.petidiTeslimGunleri) window.petidiTeslimGunleri();   // sayfadaki kartlar da aynı ile göre
      });
    }
    // Son adım: il biliniyorsa "Salı / 27 Ekim kapında 🐾", bilinmiyorsa 1–2 iş günü aralığı "27–28 Ekim / Kapında 🐾".
    function etaYaz(kargoGunu) {
      if (kargoGunu) sonKargoGunu = kargoGunu;
      adresYaz();
      if (!etaEl || !sonKargoGunu) return;
      var g = secilenIl && IL_GUN[secilenIl], ust, alt;
      if (g) {
        var t = teslimEkle(sonKargoGunu, g);
        ust = gunT[t.getDay()];
        alt = tt('tl_tarih_kapinda', '[tarih] kapında', { tarih: tt('tl_tarih', '[n] [ay]', { n: t.getDate(), ay: ayAd[t.getMonth()], ayk: ayK[t.getMonth()] }) });
      } else {
        var a = teslimEkle(sonKargoGunu, 1), b = teslimEkle(sonKargoGunu, 2);
        ust = a.getMonth() === b.getMonth()
          ? tt('eta_aralik_d', '[a]–[b] [ay]', { a: a.getDate(), b: b.getDate(), ay: ayAd[b.getMonth()], ayk: ayK[b.getMonth()] })
          : tt('eta_aralik_d2', '[a] [ay1] – [b] [ay2]', { a: a.getDate(), ay1: ayAd[a.getMonth()], ayk1: ayK[a.getMonth()], b: b.getDate(), ay2: ayAd[b.getMonth()], ayk2: ayK[b.getMonth()] });
        alt = tt('tl_kapinda', 'Kapında');
      }
      if (tlEta) tlEta.textContent = ust;
      etaEl.textContent = alt;
    }
    // IP'den il: yalnız il bilinmiyorsa, oturumda bir kez (sessionStorage). Hata/zaman aşımında aralık kalır.
    if (etaEl && !secilenIl) {
      var ipIl = null; try { ipIl = sessionStorage.getItem('petidi_il_ip'); } catch (e) {}
      if (ipIl !== null) { if (IL_GUN[ipIl]) secilenIl = ipIl; }
      else if (window.fetch) {
        fetch('https://ahtapot.petidi.workers.dev/acik/il').then(function (r) { return r.json(); }).then(function (j) {
          var il = j && IL_GUN[j.il] ? j.il : '';
          try { sessionStorage.setItem('petidi_il_ip', il); } catch (e) {}
          if (il && !secilenIl) { secilenIl = il; etaYaz(); if (window.petidiTeslimGunleri) window.petidiTeslimGunleri(); }
        }).catch(function () {});
      }
    }
    renderShipFn = renderShip;
    renderShip();
    var shipT = setInterval(renderShip, 30000);
    ac.signal.addEventListener('abort', function () { clearInterval(shipT); });
  }

  // ---- Sepete Ekle (AJAX) + bildirim overlay ----
  var form = pd.querySelector('[data-pd-form]');
  function updateCartCount() {
    if (window.petidiUpdateCartCount) window.petidiUpdateCartCount();
    fsSepet();
  }

  var atc = pd.querySelector('[data-atc]');

  // ---- Sepete eklendi penceresi: öneri rafları (snippets/oneri-kart.liquid) ----
  // Sepette zaten olan varyantın kartı gizlenir; rafta kart kalmazsa raf da gizlenir.
  function onrHazirla() {
    var onr = atc && atc.querySelector('[data-onr]');
    if (!onr) return;
    fetch((window.PETIDI_KOK || '') + '/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var sepette = {};
      (c.items || []).forEach(function (i) { sepette[String(i.variant_id)] = true; });
      onr.querySelectorAll('[data-onr-kart]').forEach(function (k) {
        if (sepette[k.getAttribute('data-vid')] && !k.classList.contains('is-eklendi')) k.hidden = true;
      });
      onr.querySelectorAll('[data-onr-blok]').forEach(function (b) {
        b.hidden = !b.querySelector('[data-onr-kart]:not([hidden])');
      });
    }).catch(function () {});
  }
  if (atc) {
    atc.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-onr-ekle]');
      if (!btn || btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('is-loading');
      var kart = btn.closest('[data-onr-kart]');
      fetch((window.PETIDI_KOK || '') + '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        // _kaynak: öneriden gelen satış ölçülebilsin (alt çizgili özellik müşteriye görünmez)
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-vid')), quantity: 1, properties: { _kaynak: btn.getAttribute('data-kaynak') || 'oneri' } }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        btn.classList.remove('is-loading');
        btn.classList.add('is-ok');
        btn.innerHTML = '✓';
        if (kart) kart.classList.add('is-eklendi');
        updateCartCount();
      }).catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
    });
  }
  // Temel kalite listesi (17 Eki 2026): basınca hemen kilit + dönen gösterge + "İşleniyor…"; ana ürün eklenip pencere açılınca
  // eski yazıya döner. Aboneliği başlatınca /cart'a gidilir, hata olursa form gönderilir → ikisinde de kilit sayfa değişene dek kalır.
  function isleniyorAc(b) {
    addIsleniyor = true;
    if (!b) return;
    b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true');   // gösterge açılışta eklendi, CSS gösterir
    if (addText) yaz(addText, tt('isleniyor', 'İşleniyor…'));
    var sy = document.querySelector('[data-pd-sticky-yazi]'); if (sy) yaz(sy, tt('isleniyor', 'İşleniyor…'));
  }
  function isleniyorKapat(b) {
    addIsleniyor = false;
    if (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }
    dugmeYazi();
  }
  // Dönen gösterge açılışta bir kez eklenir (gizli); basınca yalnız sınıf değişir — düğüm eklemek dokunuş karesinde sayfa
  // gözlemcilerini tetikliyordu (INP)
  if (addBtn && !addBtn.querySelector('.cart__donen')) { var donen = document.createElement('span'); donen.className = 'cart__donen'; donen.setAttribute('aria-hidden', 'true'); addBtn.insertBefore(donen, addText || null); }
  // Geri tuşuyla (bfcache) dönülürse düğme kilitli kalmasın (ör. abonelik → /cart → geri)
  window.addEventListener('pageshow', function (e) { if (e.persisted && addIsleniyor) isleniyorKapat(addBtn); }, sig);
  if (atc) {
    var closeAtc = function () { atc.hidden = true; document.body.style.overflow = ''; };
    atc.querySelectorAll('[data-atc-close]').forEach(function (el) { el.addEventListener('click', closeAtc); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !atc.hidden) closeAtc(); }, sig);
    if (form) {
      form.addEventListener('submit', function (e) {
        var addBtn2 = form.querySelector('[data-pd-addcart]');
        if (addBtn2 && addBtn2.disabled) return;
        e.preventDefault();
        if (addIsleniyor) return;   // istek sürerken ikinci basış (Enter / yapışık düğme) işlem yapmaz
        isleniyorAc(addBtn2);
        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var mainId = idInput ? Number(idInput.value) : 0;
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        // Petidi Club hediyesi (12 Eki 2026): hediyeler yalnız üyeye. Sepete ürün hediyeleri değil, 0 TL'lik tek
        // "Petidi Club Hediyesi" kutusu girer — yalnız kuru mamada (data-club-kutu) ve üye ya da Club seçiliyse.
        // Hediyeleri ödeme sonrası ahtapot ekler; sepet sayfası (cart.js) kutuyu hak durumuna göre ekler/çıkarır.
        var kutuId = Number((addBtn2 && addBtn2.getAttribute('data-club-kutu')) || 0);
        var clubKutuIstenir = function () {
          var c = pd.querySelector('[data-club]');
          return kutuId && ((c && c.getAttribute('data-club-uye') === '1') || !!clubEklenecek());
        };
        var giftIds = ((addBtn2 && addBtn2.getAttribute('data-giftids')) || '').split(',').filter(Boolean).map(Number);   // yalnız Club hediyeleri kapalıyken dolu
        var done = function () {
          // Nutri ödül %10 teklifi (19 Eki 2026): köpek kuru mamasında pencere önce açılır, kapanınca akış sürer (nutri-teklif.js).
          if (window.PetidiNutri && !done.ntBitti) {
            done.ntBitti = true;
            window.PetidiNutri.goster().then(done, done);
            return;
          }
          done.ntBitti = false;
          // Abonelik başlatınca yan panel değil doğrudan sepet sayfası (kullanıcı, 15 Eki 2026): kod ve sıklık orada görünür.
          if (dtVar) { window.location.href = (window.PETIDI_KOK || '') + '/cart'; return; }
          onrHazirla();
          atc.hidden = false;
          if (window.matchMedia('(max-width: 749px)').matches) document.body.style.overflow = 'hidden';
          isleniyorKapat(addBtn2);
          updateCartCount();
        };
        var fail = function () { form.submit(); };
        // Hediyeleri AYRI çağrıda ekler; hediye eklenemezse ana ürün etkilenmez.
        // (Shopify /cart/add.js'i atomik işliyor: hediye stokta değilse tek çağrıda
        // gönderilen ana ürün de sepete girmiyor, sessizce form gönderimine düşüyordu.)
        var giftAdd = function () {
          if (clubKutuIstenir()) giftIds = [kutuId];
          if (!giftIds.length) return Promise.resolve();
          return fetch((window.PETIDI_KOK || '') + '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var existing = cart.items.filter(function (i) { return i.properties && i.properties._hediye; }).map(function (i) { return i.variant_id; });
            var items = [];
            giftIds.forEach(function (id) { if (existing.indexOf(id) < 0) items.push({ id: id, quantity: 1, properties: { _hediye: '1' } }); });
            if (!items.length) return null;
            return fetch((window.PETIDI_KOK || '') + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
          }).catch(function () { return null; });
        };
        // Petidi Club seçildiyse üyelik ürünü (bir tane; sepette varsa eklenmez). Eklenemezse ana ürün yine sepette.
        var clubVid = clubEklenecek();
        var clubAdd = function () {
          if (!clubVid) return Promise.resolve();
          return fetch((window.PETIDI_KOK || '') + '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            if (cart.items.some(function (i) { return i.variant_id === clubVid; })) return null;
            return fetch((window.PETIDI_KOK || '') + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: clubVid, quantity: 1 }] }) });
          }).catch(function () { return null; });
        };
        // Abonelik (13 Eki 2026: herkese; 15 Eki: girişsiz): ana satıra `_duzenli_hafta` (ahtapot duzenli.js) + indirim kodu
        // sepete uygulanır — girişliye müşteriye özel DT…, misafire ortak ABONE… (m=1; Shopify müşteri başına bir kez).
        // Kod alınamazsa ürün yine sepette, abonelik yine açılır (yalnız ilk sipariş indirimsiz kalır).
        var anaSatir = { id: mainId, quantity: qty };
        var dtSel = pd.querySelector('[data-duzenli-hafta]'), dtH = dtSel ? parseInt(dtSel.value, 10) || 0 : 0;
        var dtVar = dtH > 0 && dtSecili();
        // Yaş mamada en az adet (30 Eki 2026): radyo zaten kapalı; yine de adet min altındaysa abonelik gönderilmez
        var dtMinA = dtMinFs ? parseInt(dtMinFs.getAttribute('data-dt-min'), 10) || 0 : 0;
        if (dtVar && dtMinA > 1 && qty * paketCarpan() < dtMinA) dtVar = false;
        if (dtVar) anaSatir.properties = { _duzenli_hafta: String(dtH) };
        var dtKod = function () {
          if (!dtVar) return Promise.resolve();
          return fetch('/apps/yorum/duzenli-kod?m=1&v=' + mainId + '&h=' + dtH + '&q=' + qty, { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (j) {
              if (!j || !j.kod) return null;
              return fetch((window.PETIDI_KOK || '') + '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
                var kodlar = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return c && c.toUpperCase() !== j.kod; });
                kodlar.push(j.kod);
                return fetch((window.PETIDI_KOK || '') + '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: kodlar.join(',') }) });
              });
            }).catch(function () { return null; });
        };
        // Ana ürün önce ve tek başına
        fetch((window.PETIDI_KOK || '') + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [anaSatir] }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); abYasamSepet(); return r.json(); })
          .then(dtKod)
          .then(clubAdd)
          .then(giftAdd)
          .then(done).catch(fail);
      });
    }
  }

  // ---- Ürün bilgileri bölümü masaüstünde sağ kolona (.pd__sagalt); galeri solda yapışık kalır ----
  var sagAlt = pd.querySelector('[data-pd-sagalt]');
  var pinfo = document.querySelector('.pinfo');
  if (sagAlt && pinfo) {
    var pinfoYer = document.querySelector('[data-pinfo-yer]');   // product-info.liquid'in satır içi betiği koyar
    if (!pinfoYer) { pinfoYer = document.createElement('span'); pinfoYer.hidden = true; pinfo.parentNode.insertBefore(pinfoYer, pinfo); }
    var genis = window.matchMedia('(min-width: 750px)');
    var pinfoYerlestir = function () {
      if (genis.matches) { if (pinfo.parentNode !== sagAlt) sagAlt.appendChild(pinfo); }
      else if (pinfo.parentNode === sagAlt) pinfoYer.parentNode.insertBefore(pinfo, pinfoYer.nextSibling);
    };
    pinfoYerlestir();
    if (genis.addEventListener) genis.addEventListener('change', pinfoYerlestir);
  }

  // ---- Orta + sağ kolon yapışık (≥1200px, base.css .pd__orta/.pd__kutu sticky) ----
  // Kolon ekrana sığıyorsa üstten 20px'te durur; sığmıyorsa altı ekranın altına 20px kala durur (top eksi) — böylece
  // uzun satın alma kutusunun altı (Club, taksit) galeri bitmeden de görülebilir.
  (function () {
    var kolonlar = [pd.querySelector('.pd__orta'), pd.querySelector('.pd__kutu')].filter(Boolean);
    if (!kolonlar.length) return;
    var genis = window.matchMedia('(min-width: 1200px)');
    function hesapla() {
      kolonlar.forEach(function (k) {
        if (!genis.matches) { k.style.removeProperty('--yapis'); return; }
        var y = Math.min(20, window.innerHeight - k.offsetHeight - 20);
        k.style.setProperty('--yapis', y + 'px');
      });
    }
    hesapla();
    window.addEventListener('resize', hesapla, sig);
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(hesapla); kolonlar.forEach(function (k) { ro.observe(k); }); ac.signal.addEventListener('abort', function () { ro.disconnect(); }); }
  })();

  // ---- Masaüstü alt yapışık Sepete Ekle çubuğu (.pd__sticky) ----
  // Asıl satın alma çubuğu (.pd__buybar) ekranın ÜSTÜNDEN çıkınca açılır; düğmesi asıl Sepete Ekle'ye tıklar.
  var stk = document.querySelector('[data-pd-sticky]');
  var asilBar = pd.querySelector('.pd__buybar');
  if (stk && asilBar && 'IntersectionObserver' in window) {
    var stkFiyat = stk.querySelector('[data-pd-sticky-fiyat]');
    var stkBtn = stk.querySelector('[data-pd-sticky-ekle]');
    var masaustu = window.matchMedia('(min-width: 750px)');
    var stkGoster = function (acik) {
      acik = acik && masaustu.matches;
      if (acik && stkFiyat && nowEl) stkFiyat.textContent = nowEl.textContent;
      if (stkBtn && addBtn) stkBtn.disabled = addBtn.disabled;
      stk.classList.toggle('is-on', acik);
      stk.setAttribute('aria-hidden', acik ? 'false' : 'true');
      stkBtn.tabIndex = acik ? 0 : -1;
      pd.classList.toggle('has-sticky', acik);
    };
    var stkIo = new IntersectionObserver(function (g) {
      var e = g[0];
      stkGoster(!e.isIntersecting && e.boundingClientRect.top < 0);
    });
    stkIo.observe(asilBar);
    ac.signal.addEventListener('abort', function () { stkIo.disconnect(); });
    if (stkBtn) stkBtn.addEventListener('click', function () { if (addBtn && !addBtn.disabled) addBtn.click(); });
  }

  // ---- Taksit açılır kutusu (sağ kolon, details[data-taksit-modal]) ----
  // Tablo PayTR'ye gitmeden tema ayarındaki oranlarla: toplam = fiyat ÷ (1 − oran/100), aylık = toplam ÷ taksit
  // (PayTR'nin kendi tablosuyla birebir, 11 Eki 2026'da doğrulandı). İlk tablo Liquid'de; boy değişince burada yenilenir.
  var tModal = pd.querySelector('[data-taksit-modal]');
  if (tModal) {
    var tGovde = tModal.querySelector('[data-taksit-govde]');
    var tMax = Number(tModal.getAttribute('data-max')) || 6;
    var tPesin = tModal.getAttribute('data-mod') === 'pesin';
    var tOran = (tModal.getAttribute('data-oranlar') || '').split(',').map(function (x) {
      var p = x.split(':'); return { n: parseInt(p[0], 10), r: parseFloat(String(p[1] || '').replace(',', '.')) };
    }).filter(function (o) { return o.n >= 2 && o.n <= tMax && (tPesin || (o.r >= 0 && o.r < 100)); });
    var tTL = function (k) { return (k / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; };
    var tYaz = function () {
      if (!tGovde || !currentPriceCents) return;
      var f = currentPriceCents, h = '<tr><td>' + tt('tek_cekim', 'Tek çekim') + '</td><td>' + tTL(f) + '</td><td>' + tTL(f) + '</td></tr>';
      tOran.forEach(function (o) {
        var top = tPesin ? f : Math.round(f * 100 / (100 - o.r));
        h += '<tr><td>' + tt('n_taksit', '[n] taksit', { n: o.n }) + '</td><td>' + tTL(Math.round(top / o.n)) + '</td><td>' + tTL(top) + '</td></tr>';
      });
      tGovde.innerHTML = h;
    };
    // Boy değişince tablo selectVariant'ın 2. adımında (çizimden sonra) yenilenir (17 Eki 2026; eskiden ayrı tıklama dinleyicisi)
  }

};
window.petidiUrunKur();

// Aroma düğmeleri (snippets/aroma-secim, 13 Eki 2026; kullanıcı: "rakip sayfa yeniletmiyor"): kardeş ürüne geçiş SAYFA
// YENİLENMEDEN — kardeşin sayfası arka planda alınır (üzerine gelince / dokununca önceden), #MainContent'teki bölümler
// yerinde değişir, adres pushState ile değişir (Geri tuşu önceki tada döner), bölüm içi betikler yeniden çalışır,
// petidiUrunKur() + Pati Profili + teslim günü yeniden kurulur. Seçili boy yeni üründe STOKTAYSA seçilir, yoksa ürünün
// varsayılanı kalır. Bir şey ters giderse normal sayfa geçişine düşer.
(function () {
  if (!document.querySelector('[data-pd-aroma]')) return;
  var ana = document.getElementById('MainContent');
  if (!ana || !window.DOMParser || !window.fetch) return;
  var onbellek = {};
  function temiz(u) { var a = document.createElement('a'); a.href = u; return a.origin + a.pathname; }
  function al(u) {
    u = temiz(u);
    if (!onbellek[u]) onbellek[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
    onbellek[u].catch(function () { delete onbellek[u]; });
    return onbellek[u];
  }
  var suanki = temiz(location.href);
  try { history.replaceState(Object.assign({}, history.state || {}, { aroma: location.href }), ''); } catch (e) {}

  function betikleriCalistir(kok) {
    kok.querySelectorAll('script').forEach(function (eski) {
      var tip = (eski.getAttribute('type') || '').toLowerCase();
      if (tip && tip !== 'text/javascript' && tip !== 'module') return;   // JSON / JSON-LD: veri, çalıştırılmaz
      if (eski.src) return;   // dış dosyalar sayfada zaten yüklü (product.js, rich-text.js …); kurulum aşağıda
      var yeni = document.createElement('script');
      yeni.textContent = eski.textContent;
      eski.parentNode.replaceChild(yeni, eski);
    });
  }
  function uygula(html, url, ekle) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var yeniAna = doc.getElementById('MainContent');
    var eskiB = ana.querySelectorAll(':scope > .shopify-section'), yeniB = yeniAna ? yeniAna.querySelectorAll(':scope > .shopify-section') : [];
    if (!yeniB.length || !yeniAna.querySelector('[data-pd]')) throw new Error('bolum');
    eskiB.forEach(function (b) { b.remove(); });
    yeniB.forEach(function (b) { ana.appendChild(document.adoptNode(b)); });
    document.title = doc.title;
    ['link[rel="canonical"]', 'meta[name="description"]', 'meta[property="og:title"]', 'meta[property="og:url"]', 'meta[property="og:image"]'].forEach(function (sel) {
      var e = document.head.querySelector(sel), y = doc.head.querySelector(sel);
      if (e && y) { if (e.tagName === 'LINK') e.href = y.href; else e.content = y.content; }
    });
    if (ekle) history.pushState({ aroma: url }, '', url);
    suanki = temiz(url);
    ana.querySelectorAll(':scope > .shopify-section').forEach(function (b) { betikleriCalistir(b); });
    if (window.petidiUrunKur) window.petidiUrunKur();
    ana.querySelectorAll(':scope > .shopify-section').forEach(function (b) {
      try { b.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: b.id.replace('shopify-section-', '') } })); } catch (e) {}
    });
    if (window.PetidiPetProfile && window.PetidiPetProfile.yenidenCiz) window.PetidiPetProfile.yenidenCiz();
    if (window.petidiTeslimGunleri) window.petidiTeslimGunleri();
  }
  function boyuSec(t) {
    if (!t) return;
    var hedef = null;
    document.querySelectorAll('.pd__variant').forEach(function (b) {
      var ad = b.querySelector('.pd__variant-ad');
      if (ad && ad.textContent.trim() === t && !b.classList.contains('is-out') && !b.disabled) hedef = b;
    });
    if (hedef && !hedef.classList.contains('is-selected')) hedef.click();
  }
  function gec(url, ekle, boy) {
    al(url).then(function (html) {
      var yap = function () { uygula(html, url, ekle); boyuSec(boy); };
      if (document.startViewTransition) document.startViewTransition(yap); else yap();
    }).catch(function () { location.href = url; });
  }
  function hedefA(e) { return e.target.closest && e.target.closest('[data-aroma-link]'); }
  document.addEventListener('pointerover', function (e) { var a = hedefA(e); if (a) al(a.href); });
  document.addEventListener('touchstart', function (e) { var a = hedefA(e); if (a) al(a.href); }, { passive: true });
  document.addEventListener('click', function (e) {
    var a = hedefA(e);
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    e.preventDefault();
    var secili = document.querySelector('.pd__variant.is-selected .pd__variant-ad');
    gec(temiz(a.href), true, secili ? secili.textContent.trim() : '');
  });
  window.addEventListener('popstate', function (e) {
    if (!e.state || !e.state.aroma) return;
    if (temiz(e.state.aroma) === suanki) return;   // ör. tam ekran galeriden geri
    gec(e.state.aroma, false, '');
  });
})();
